import _toConsumableArray from "/home/circleci/repo/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "/home/circleci/repo/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/home/circleci/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "core-js/modules/esnext.global-this.js";
import _regeneratorRuntime from "/home/circleci/repo/node_modules/@babel/runtime/regenerator/index.js";
import t from "axios";
import e, { useCallback as n, useState as r, useRef as o, useEffect as i, useContext as a, createContext as u, useLayoutEffect as c, useMemo as s } from "react";
import l from "classnames";
import p from "prop-types";
import f from "lodash/isEqual";
import d, { enableES5 as m } from "immer";
import v from "use-persisted-state";
import { weAreServer as y } from "use-ssr";
import g from "lodash/omit";
import { parse as w, match as b, compile as E } from "path-to-regexp";
import _ from "query-string";
function O() {
  return (O = Object.assign || function (t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];
      for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
    }
    return t;
  }).apply(this, arguments);
}
function P(e, a) {
  var u = n(function () {
      return t.create(e);
    }, []),
    _r = r(a),
    _r2 = _slicedToArray(_r, 2),
    c = _r2[0],
    s = _r2[1],
    _r3 = r(null),
    _r4 = _slicedToArray(_r3, 2),
    l = _r4[0],
    p = _r4[1],
    _r5 = r(!1),
    _r6 = _slicedToArray(_r5, 2),
    f = _r6[0],
    h = _r6[1],
    _r7 = r(null),
    _r8 = _slicedToArray(_r7, 2),
    d = _r8[0],
    m = _r8[1],
    v = o({});
  return i(function () {
    return v.current.cancelToken = new t.CancelToken(function (t) {
      v.current.cancelRequest = t;
    }), function () {
      v.current.unmounted = !0, v.current.cancelRequest && v.current.cancelRequest();
    };
  }, []), i(function () {
    l && !v.current.unmounted && _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _t2;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            m(null), h(!0);
            _context.prev = 1;
            _context.next = 4;
            return u(O({
              method: l.data ? "post" : "get"
            }, l, {
              cancelToken: v.current.cancelToken
            }));
          case 4:
            _t2 = _context.sent;
            s(_t2.data), h(!1);
            _context.next = 11;
            break;
          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](1);
            v.current.unmounted || (m(_context.t0), h(!1));
          case 11:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 8]]);
    }))();
  }, [l]), [{
    data: c,
    isLoading: f,
    isError: !!d,
    error: d
  }, p];
}
var x = function x(t) {
    return function () {
      for (var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++) {
        e[_key] = arguments[_key];
      }
      var n = l(e).split(/\s+/g),
        r = n.find(function (t) {
          return t.startsWith("__");
        }) || "";
      return n = n.map(function (e) {
        return e.startsWith("--") ? "".concat(t).concat(r).concat(e) : e.startsWith("__") ? null : e;
      }), l("".concat(t).concat(r), n);
    };
  },
  R = function R(t) {
    return t || (t = a(C).namespace), x(t);
  },
  C = u({
    namespace: null
  }),
  S = C.Provider;
function U(_ref2) {
  var t = _ref2.namespace,
    e = _ref2.children;
  return h(S, {
    value: {
      namespace: t
    }
  }, "function" == typeof e ? h(e, null) : e);
}
function N(t, e) {
  return t ? t.clientWidth : e;
}
function D(t) {
  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    width: 0,
    height: 0
  };
  var _r9 = r(N(t ? t.current : {}, e.width)),
    _r10 = _slicedToArray(_r9, 2),
    o = _r10[0],
    i = _r10[1],
    _r11 = r(N(t ? t.current : {}, e.height)),
    _r12 = _slicedToArray(_r11, 2),
    a = _r12[0],
    u = _r12[1];
  var s = n(function () {
    var e;
    t.current && (i(N(t.current)), u((e = t.current) ? e.clientHeight : void 0));
  }, [t]);
  return c(function () {
    if (t.current) {
      if (s(), "function" == typeof ResizeObserver) {
        var e = new ResizeObserver(function () {
          s();
        });
        return e.observe(t.current), function () {
          e.disconnect(t.current), e = null;
        };
      }
      return window.addEventListener("resize", s), function () {
        window.removeEventListener("resize", s);
      };
    }
  }, [t.current]), {
    width: o,
    height: a
  };
}
U.propTypes = {
  namespace: p.string.isRequired,
  children: p.oneOfType([p.func, p.node])
};
var T = t.create({
  baseURL: process.env.GATSBY_API_URL
});
function j(e) {
  var _r13 = r(e),
    _r14 = _slicedToArray(_r13, 2),
    n = _r14[0],
    a = _r14[1],
    _r15 = r(null),
    _r16 = _slicedToArray(_r15, 2),
    u = _r16[0],
    c = _r16[1],
    _r17 = r(!1),
    _r18 = _slicedToArray(_r17, 2),
    s = _r18[0],
    l = _r18[1],
    _r19 = r(null),
    _r20 = _slicedToArray(_r19, 2),
    p = _r20[0],
    f = _r20[1],
    h = o({});
  return i(function () {
    return h.current.cancelToken = new t.CancelToken(function (t) {
      h.current.cancelRequest = t;
    }), function () {
      h.current.unmounted = !0, h.current.cancelRequest && h.current.cancelRequest();
    };
  }, []), i(function () {
    u && !h.current.unmounted && _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var _t3;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            f(null), l(!0);
            _context2.prev = 1;
            if (process.env.GATSBY_API_URL) {
              _context2.next = 4;
              break;
            }
            throw new Error("GATSBY_API_URL not set");
          case 4:
            _context2.next = 6;
            return T(O({
              method: u.data ? "post" : "get"
            }, u, {
              cancelToken: h.current.cancelToken
            }));
          case 6:
            _t3 = _context2.sent;
            a(_t3.data), l(!1);
            _context2.next = 13;
            break;
          case 10:
            _context2.prev = 10;
            _context2.t0 = _context2["catch"](1);
            h.current.unmounted || (f(_context2.t0), l(!1));
          case 13:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[1, 10]]);
    }))();
  }, [u]), [{
    data: n,
    isLoading: s,
    isError: !!p,
    error: p
  }, c];
}
function F(t) {
  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : f;
  var n = o();
  return e(t, n.current) || (n.current = t), n.current;
}
function W(t, e) {
  var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : f;
  i(t, [t].concat(_toConsumableArray(F(e, n))));
}
function A() {
  var _r21 = r(!1),
    _r22 = _slicedToArray(_r21, 2),
    t = _r22[0],
    e = _r22[1];
  return i(function () {
    e(!0);
  }, []), t;
}
var k = "undefined" != typeof window && !!window.MSInputMethodContext && !!document.documentMode;
function q() {
  return A() && k;
}
function I() {
  return A() && !k;
}
function M(_ref4) {
  var t = _ref4.children;
  return A() && k ? h(Fragment, null, t) : null;
}
function B(_ref5) {
  var t = _ref5.children;
  return A() && !k ? h(Fragment, null, t) : null;
}
var L = function L(t, e, n, r, o, i, a, u) {
    if ("production" !== process.env.NODE_ENV && void 0 === e) throw new Error("invariant requires an error message argument");
    if (!t) {
      var c;
      if (void 0 === e) c = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else {
        var s = [n, r, o, i, a, u],
          l = 0;
        (c = new Error(e.replace(/%s/g, function () {
          return s[l++];
        }))).name = "Invariant Violation";
      }
      throw c.framesToPop = 1, c;
    }
  },
  V = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {};
function $(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
function z(t) {
  var e = {
    exports: {}
  };
  return t(e, e.exports), e.exports;
}
var G = "__global_unique_id__",
  K = function K() {
    return V[G] = (V[G] || 0) + 1;
  },
  Y = function Y() {};
if ("production" !== process.env.NODE_ENV) {
  var H = function H(t, e) {
    var n = arguments.length;
    e = new Array(n > 1 ? n - 1 : 0);
    for (var r = 1; r < n; r++) e[r - 1] = arguments[r];
    var o = 0,
      i = "Warning: " + t.replace(/%s/g, function () {
        return e[o++];
      });
    "undefined" != typeof console && console.error(i);
    try {
      throw new Error(i);
    } catch (t) {}
  };
  Y = function Y(t, e, n) {
    var r = arguments.length;
    n = new Array(r > 2 ? r - 2 : 0);
    for (var o = 2; o < r; o++) n[o - 2] = arguments[o];
    if (void 0 === e) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
    t || H.apply(null, [e].concat(n));
  };
}
var J = Y,
  Q = z(function (t, n) {
    n.__esModule = !0;
    var r = a(p),
      o = a(K),
      i = a(J);
    function a(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }
    function u(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }
    function c(t, e) {
      if (!t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !e || "object" != typeof e && "function" != typeof e ? t : e;
    }
    function s(t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
    }
    var l = 1073741823;
    function f(t) {
      var e = [];
      return {
        on: function on(t) {
          e.push(t);
        },
        off: function off(t) {
          e = e.filter(function (e) {
            return e !== t;
          });
        },
        get: function get() {
          return t;
        },
        set: function set(n, r) {
          t = n, e.forEach(function (e) {
            return e(t, r);
          });
        }
      };
    }
    n.default = function (t, n) {
      var a,
        p,
        h = "__create-react-context-" + (0, o.default)() + "__",
        d = function (t) {
          function e() {
            var n, r;
            u(this, e);
            for (var o = arguments.length, i = Array(o), a = 0; a < o; a++) i[a] = arguments[a];
            return n = r = c(this, t.call.apply(t, [this].concat(i))), r.emitter = f(r.props.value), c(r, n);
          }
          return s(e, t), e.prototype.getChildContext = function () {
            var t;
            return (t = {})[h] = this.emitter, t;
          }, e.prototype.componentWillReceiveProps = function (t) {
            if (this.props.value !== t.value) {
              var e = this.props.value,
                r = t.value,
                o = void 0;
              ((a = e) === (u = r) ? 0 !== a || 1 / a == 1 / u : a != a && u != u) ? o = 0 : (o = "function" == typeof n ? n(e, r) : l, "production" !== process.env.NODE_ENV && (0, i.default)((o & l) === o, "calculateChangedBits: Expected the return value to be a 31-bit integer. Instead received: %s", o), 0 != (o |= 0) && this.emitter.set(t.value, o));
            }
            var a, u;
          }, e.prototype.render = function () {
            return this.props.children;
          }, e;
        }(e.Component);
      d.childContextTypes = ((a = {})[h] = r.default.object.isRequired, a);
      var m = function (e) {
        function n() {
          var t, r;
          u(this, n);
          for (var o = arguments.length, i = Array(o), a = 0; a < o; a++) i[a] = arguments[a];
          return t = r = c(this, e.call.apply(e, [this].concat(i))), r.state = {
            value: r.getValue()
          }, r.onUpdate = function (t, e) {
            0 != ((0 | r.observedBits) & e) && r.setState({
              value: r.getValue()
            });
          }, c(r, t);
        }
        return s(n, e), n.prototype.componentWillReceiveProps = function (t) {
          var e = t.observedBits;
          this.observedBits = null == e ? l : e;
        }, n.prototype.componentDidMount = function () {
          this.context[h] && this.context[h].on(this.onUpdate);
          var t = this.props.observedBits;
          this.observedBits = null == t ? l : t;
        }, n.prototype.componentWillUnmount = function () {
          this.context[h] && this.context[h].off(this.onUpdate);
        }, n.prototype.getValue = function () {
          return this.context[h] ? this.context[h].get() : t;
        }, n.prototype.render = function () {
          return (t = this.props.children, Array.isArray(t) ? t[0] : t)(this.state.value);
          var t;
        }, n;
      }(e.Component);
      return m.contextTypes = ((p = {})[h] = r.default.object, p), {
        Provider: d,
        Consumer: m
      };
    }, t.exports = n.default;
  }),
  X = $(z(function (t, n) {
    n.__esModule = !0;
    var r = i(e),
      o = i(Q);
    function i(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }
    n.default = r.default.createContext || o.default, t.exports = n.default;
  }));
function Z() {
  var t = this.constructor.getDerivedStateFromProps(this.props, this.state);
  null != t && this.setState(t);
}
function tt(t) {
  this.setState(function (e) {
    var n = this.constructor.getDerivedStateFromProps(t, e);
    return null != n ? n : null;
  }.bind(this));
}
function et(t, e) {
  try {
    var n = this.props,
      r = this.state;
    this.props = t, this.state = e, this.__reactInternalSnapshotFlag = !0, this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(n, r);
  } finally {
    this.props = n, this.state = r;
  }
}
Z.__suppressDeprecationWarning = !0, tt.__suppressDeprecationWarning = !0, et.__suppressDeprecationWarning = !0;
var nt,
  rt,
  ot,
  it,
  at,
  ut = function ut(t, e) {
    return t.substr(0, e.length) === e;
  },
  ct = function ct(t, e) {
    if (ut(t, "/")) return t;
    var n = t.split("?"),
      r = n[0],
      o = n[1],
      i = e.split("?")[0],
      a = dt(r),
      u = dt(i);
    if ("" === a[0]) return mt(i, o);
    if (!ut(a[0], ".")) {
      var c = u.concat(a).join("/");
      return mt(("/" === i ? "" : "/") + c, o);
    }
    for (var s = u.concat(a), l = [], p = 0, f = s.length; p < f; p++) {
      var h = s[p];
      ".." === h ? l.pop() : "." !== h && l.push(h);
    }
    return mt("/" + l.join("/"), o);
  },
  st = function st(t, e) {
    var n = t.split("?"),
      r = n[1],
      o = void 0 === r ? "" : r,
      i = "/" + dt(n[0]).map(function (t) {
        var n = lt.exec(t);
        return n ? e[n[1]] : t;
      }).join("/"),
      a = e.location,
      u = (a = void 0 === a ? {} : a).search,
      c = (void 0 === u ? "" : u).split("?")[1] || "";
    return mt(i, o, c);
  },
  lt = /^:(.+)/,
  pt = function pt(t) {
    return lt.test(t);
  },
  ft = function ft(t) {
    return t && "*" === t[0];
  },
  ht = function ht(t, e) {
    return {
      route: t,
      score: t.default ? 0 : dt(t.path).reduce(function (t, e) {
        return t += 4, function (t) {
          return "" === t;
        }(e) ? t += 1 : pt(e) ? t += 2 : ft(e) ? t -= 5 : t += 3, t;
      }, 0),
      index: e
    };
  },
  dt = function dt(t) {
    return t.replace(/(^\/+|\/+$)/g, "").split("/");
  },
  mt = function mt(t) {
    for (var e = arguments.length, n = Array(e > 1 ? e - 1 : 0), r = 1; r < e; r++) n[r - 1] = arguments[r];
    return t + ((n = n.filter(function (t) {
      return t && t.length > 0;
    })) && n.length > 0 ? "?" + n.join("&") : "");
  },
  vt = ["uri", "path"],
  yt = Object.assign || function (t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];
      for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
    }
    return t;
  },
  gt = function gt(t) {
    var e = t.location,
      n = e.search,
      r = e.hash,
      o = e.href,
      i = e.origin,
      a = e.protocol,
      u = e.host,
      c = e.hostname,
      s = e.port,
      l = t.location.pathname;
    return !l && o && wt && (l = new URL(o).pathname), {
      pathname: encodeURI(decodeURI(l)),
      search: n,
      hash: r,
      href: o,
      origin: i,
      protocol: a,
      host: u,
      hostname: c,
      port: s,
      state: t.history.state,
      key: t.history.state && t.history.state.key || "initial"
    };
  },
  wt = !("undefined" == typeof window || !window.document || !window.document.createElement),
  bt = (nt = wt ? window : function () {
    var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "/",
      e = t.indexOf("?"),
      n = {
        pathname: e > -1 ? t.substr(0, e) : t,
        search: e > -1 ? t.substr(e) : ""
      },
      r = 0,
      o = [n],
      i = [null];
    return {
      get location() {
        return o[r];
      },
      addEventListener: function addEventListener(t, e) {},
      removeEventListener: function removeEventListener(t, e) {},
      history: {
        get entries() {
          return o;
        },
        get index() {
          return r;
        },
        get state() {
          return i[r];
        },
        pushState: function pushState(t, e, n) {
          var a = n.split("?"),
            u = a[1],
            c = void 0 === u ? "" : u;
          r++, o.push({
            pathname: a[0],
            search: c.length ? "?" + c : c
          }), i.push(t);
        },
        replaceState: function replaceState(t, e, n) {
          var a = n.split("?"),
            u = a[1];
          o[r] = {
            pathname: a[0],
            search: void 0 === u ? "" : u
          }, i[r] = t;
        },
        go: function go(t) {
          var e = r + t;
          e < 0 || e > i.length - 1 || (r = e);
        }
      }
    };
  }(), rt = [], ot = gt(nt), it = !1, at = function at() {}, {
    get location() {
      return ot;
    },
    get transitioning() {
      return it;
    },
    _onTransitionComplete: function _onTransitionComplete() {
      it = !1, at();
    },
    listen: function listen(t) {
      rt.push(t);
      var e = function e() {
        ot = gt(nt), t({
          location: ot,
          action: "POP"
        });
      };
      return nt.addEventListener("popstate", e), function () {
        nt.removeEventListener("popstate", e), rt = rt.filter(function (e) {
          return e !== t;
        });
      };
    },
    navigate: function navigate(t) {
      var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
        n = e.state,
        r = e.replace,
        o = void 0 !== r && r;
      if ("number" == typeof t) nt.history.go(t);else {
        n = yt({}, n, {
          key: Date.now() + ""
        });
        try {
          it || o ? nt.history.replaceState(n, null, t) : nt.history.pushState(n, null, t);
        } catch (e) {
          nt.location[o ? "replace" : "assign"](t);
        }
      }
      ot = gt(nt), it = !0;
      var i = new Promise(function (t) {
        return at = t;
      });
      return rt.forEach(function (t) {
        return t({
          location: ot,
          action: "PUSH"
        });
      }), i;
    }
  }),
  Et = Object.assign || function (t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];
      for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
    }
    return t;
  };
function _t(t, e) {
  var n = {};
  for (var r in t) e.indexOf(r) >= 0 || Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]);
  return n;
}
function Ot(t, e) {
  if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
}
function Pt(t, e) {
  if (!t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return !e || "object" != typeof e && "function" != typeof e ? t : e;
}
function xt(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
}
var Rt = function Rt(t, e) {
    var n = X(e);
    return n.displayName = t, n;
  },
  Ct = Rt("Location"),
  St = function St(t) {
    var n = t.children;
    return e.createElement(Ct.Consumer, null, function (t) {
      return t ? n(t) : e.createElement(Ut, null, n);
    });
  },
  Ut = function (t) {
    function n() {
      var e, r;
      Ot(this, n);
      for (var o = arguments.length, i = Array(o), a = 0; a < o; a++) i[a] = arguments[a];
      return e = r = Pt(this, t.call.apply(t, [this].concat(i))), r.state = {
        context: r.getContext(),
        refs: {
          unlisten: null
        }
      }, Pt(r, e);
    }
    return xt(n, t), n.prototype.getContext = function () {
      var t = this.props.history;
      return {
        navigate: t.navigate,
        location: t.location
      };
    }, n.prototype.componentDidCatch = function (t, e) {
      if (!Lt(t)) throw t;
      (0, this.props.history.navigate)(t.uri, {
        replace: !0
      });
    }, n.prototype.componentDidUpdate = function (t, e) {
      e.context.location !== this.state.context.location && this.props.history._onTransitionComplete();
    }, n.prototype.componentDidMount = function () {
      var t = this,
        e = this.state.refs,
        n = this.props.history;
      n._onTransitionComplete(), e.unlisten = n.listen(function () {
        Promise.resolve().then(function () {
          requestAnimationFrame(function () {
            t.unmounted || t.setState(function () {
              return {
                context: t.getContext()
              };
            });
          });
        });
      });
    }, n.prototype.componentWillUnmount = function () {
      var t = this.state.refs;
      this.unmounted = !0, t.unlisten();
    }, n.prototype.render = function () {
      var t = this.state.context,
        n = this.props.children;
      return e.createElement(Ct.Provider, {
        value: t
      }, "function" == typeof n ? n(t) : n || null);
    }, n;
  }(e.Component);
Ut.defaultProps = {
  history: bt
}, "production" !== process.env.NODE_ENV && (Ut.propTypes = {
  history: p.object.isRequired
});
var Nt = Rt("Base", {
    baseuri: "/",
    basepath: "/"
  }),
  Dt = function Dt(t) {
    return e.createElement(Nt.Consumer, null, function (n) {
      return e.createElement(St, null, function (r) {
        return e.createElement(Tt, Et({}, n, r, t));
      });
    });
  },
  Tt = function (t) {
    function n() {
      return Ot(this, n), Pt(this, t.apply(this, arguments));
    }
    return xt(n, t), n.prototype.render = function () {
      var t = this.props,
        n = t.location,
        r = t.navigate,
        o = t.basepath,
        i = t.primary,
        a = t.children,
        u = t.component,
        c = void 0 === u ? "div" : u,
        s = _t(t, ["location", "navigate", "basepath", "primary", "children", "baseuri", "component"]),
        l = function (t, e) {
          for (var n = void 0, r = void 0, o = e.split("?"), i = dt(o[0]), a = "" === i[0], u = function (t) {
              return t.map(ht).sort(function (t, e) {
                return t.score < e.score ? 1 : t.score > e.score ? -1 : t.index - e.index;
              });
            }(t), c = 0, s = u.length; c < s; c++) {
            var l = !1,
              p = u[c].route;
            if (p.default) r = {
              route: p,
              params: {},
              uri: e
            };else {
              for (var f = dt(p.path), h = {}, d = Math.max(i.length, f.length), m = 0; m < d; m++) {
                var v = f[m],
                  y = i[m];
                if (ft(v)) {
                  h[v.slice(1) || "*"] = i.slice(m).map(decodeURIComponent).join("/");
                  break;
                }
                if (void 0 === y) {
                  l = !0;
                  break;
                }
                var g = lt.exec(v);
                if (g && !a) {
                  -1 === vt.indexOf(g[1]) || ("production" !== process.env.NODE_ENV ? L(!1, '<Router> dynamic segment "' + g[1] + '" is a reserved name. Please use a different name in path "' + p.path + '".') : L(!1));
                  var w = decodeURIComponent(y);
                  h[g[1]] = w;
                } else if (v !== y) {
                  l = !0;
                  break;
                }
              }
              if (!l) {
                n = {
                  route: p,
                  params: h,
                  uri: "/" + i.slice(0, m).join("/")
                };
                break;
              }
            }
          }
          return n || r || null;
        }(e.Children.toArray(a).reduce(function (t, e) {
          var n = Gt(o)(e);
          return t.concat(n);
        }, []), n.pathname);
      if (l) {
        var p = l.params,
          f = l.uri,
          h = l.route,
          d = l.route.value;
        o = h.default ? o : h.path.replace(/\*$/, "");
        var m = Et({}, p, {
            uri: f,
            location: n,
            navigate: function navigate(t, e) {
              return r(ct(t, f), e);
            }
          }),
          v = e.cloneElement(d, m, d.props.children ? e.createElement(Dt, {
            location: n,
            primary: i
          }, d.props.children) : void 0),
          y = i ? Ft : c,
          g = i ? Et({
            uri: f,
            location: n,
            component: c
          }, s) : s;
        return e.createElement(Nt.Provider, {
          value: {
            baseuri: f,
            basepath: o
          }
        }, e.createElement(y, g, v));
      }
      return null;
    }, n;
  }(e.PureComponent);
Tt.defaultProps = {
  primary: !0
};
var jt = Rt("Focus"),
  Ft = function Ft(t) {
    var n = t.uri,
      r = t.location,
      o = t.component,
      i = _t(t, ["uri", "location", "component"]);
    return e.createElement(jt.Consumer, null, function (t) {
      return e.createElement(kt, Et({}, i, {
        component: o,
        requestFocus: t,
        uri: n,
        location: r
      }));
    });
  },
  Wt = !0,
  At = 0,
  kt = function (t) {
    function n() {
      var e, r;
      Ot(this, n);
      for (var o = arguments.length, i = Array(o), a = 0; a < o; a++) i[a] = arguments[a];
      return e = r = Pt(this, t.call.apply(t, [this].concat(i))), r.state = {}, r.requestFocus = function (t) {
        !r.state.shouldFocus && t && t.focus();
      }, Pt(r, e);
    }
    return xt(n, t), n.getDerivedStateFromProps = function (t, e) {
      return Et(null == e.uri ? {
        shouldFocus: !0
      } : {
        shouldFocus: t.uri !== e.uri || e.location.pathname !== t.location.pathname && t.location.pathname === t.uri
      }, t);
    }, n.prototype.componentDidMount = function () {
      At++, this.focus();
    }, n.prototype.componentWillUnmount = function () {
      0 == --At && (Wt = !0);
    }, n.prototype.componentDidUpdate = function (t, e) {
      t.location !== this.props.location && this.state.shouldFocus && this.focus();
    }, n.prototype.focus = function () {
      if ("test" !== process.env.NODE_ENV) {
        var t = this.props.requestFocus;
        t ? t(this.node) : Wt ? Wt = !1 : this.node && (this.node.contains(document.activeElement) || this.node.focus());
      }
    }, n.prototype.render = function () {
      var t = this,
        n = this.props,
        r = n.style,
        o = n.component,
        i = void 0 === o ? "div" : o,
        a = _t(n, ["children", "style", "requestFocus", "component", "uri", "location"]);
      return e.createElement(i, Et({
        style: Et({
          outline: "none"
        }, r),
        tabIndex: "-1",
        ref: function ref(e) {
          return t.node = e;
        }
      }, a), e.createElement(jt.Provider, {
        value: this.requestFocus
      }, this.props.children));
    }, n;
  }(e.Component);
!function (t) {
  var e = t.prototype;
  if (!e || !e.isReactComponent) throw new Error("Can only polyfill class components");
  if ("function" != typeof t.getDerivedStateFromProps && "function" != typeof e.getSnapshotBeforeUpdate) return t;
  var n = null,
    r = null,
    o = null;
  if ("function" == typeof e.componentWillMount ? n = "componentWillMount" : "function" == typeof e.UNSAFE_componentWillMount && (n = "UNSAFE_componentWillMount"), "function" == typeof e.componentWillReceiveProps ? r = "componentWillReceiveProps" : "function" == typeof e.UNSAFE_componentWillReceiveProps && (r = "UNSAFE_componentWillReceiveProps"), "function" == typeof e.componentWillUpdate ? o = "componentWillUpdate" : "function" == typeof e.UNSAFE_componentWillUpdate && (o = "UNSAFE_componentWillUpdate"), null !== n || null !== r || null !== o) throw Error("Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n" + (t.displayName || t.name) + " uses " + ("function" == typeof t.getDerivedStateFromProps ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()") + " but also contains the following legacy lifecycles:" + (null !== n ? "\n  " + n : "") + (null !== r ? "\n  " + r : "") + (null !== o ? "\n  " + o : "") + "\n\nThe above lifecycles should be removed. Learn more about this warning here:\nhttps://fb.me/react-async-component-lifecycle-hooks");
  if ("function" == typeof t.getDerivedStateFromProps && (e.componentWillMount = Z, e.componentWillReceiveProps = tt), "function" == typeof e.getSnapshotBeforeUpdate) {
    if ("function" != typeof e.componentDidUpdate) throw new Error("Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype");
    e.componentWillUpdate = et;
    var i = e.componentDidUpdate;
    e.componentDidUpdate = function (t, e, n) {
      i.call(this, t, e, this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : n);
    };
  }
}(kt);
var qt = function qt() {},
  It = e.forwardRef;
void 0 === It && (It = function It(t) {
  return t;
});
var Mt = It(function (t, n) {
  var r = t.innerRef,
    o = _t(t, ["innerRef"]);
  return e.createElement(Nt.Consumer, null, function (t) {
    var i = t.baseuri;
    return e.createElement(St, null, function (t) {
      var a = t.location,
        u = t.navigate,
        c = o.to,
        s = o.state,
        l = o.replace,
        p = o.getProps,
        f = void 0 === p ? qt : p,
        h = _t(o, ["to", "state", "replace", "getProps"]),
        d = ct(c, i),
        m = encodeURI(d),
        v = a.pathname === m,
        y = ut(a.pathname, m);
      return e.createElement("a", Et({
        ref: n || r,
        "aria-current": v ? "page" : void 0
      }, h, f({
        isCurrent: v,
        isPartiallyCurrent: y,
        href: d,
        location: a
      }), {
        href: d,
        onClick: function onClick(t) {
          if (h.onClick && h.onClick(t), Kt(t)) {
            t.preventDefault();
            var e = l;
            if ("boolean" != typeof l && v) {
              var n = _t(Et({}, a.state), ["key"]);
              r = Et({}, s), o = n, e = (i = Object.keys(r)).length === Object.keys(o).length && i.every(function (t) {
                return o.hasOwnProperty(t) && r[t] === o[t];
              });
            }
            u(d, {
              state: s,
              replace: e
            });
          }
          var r, o, i;
        }
      }));
    });
  });
});
function Bt(t) {
  this.uri = t;
}
Mt.displayName = "Link", "production" !== process.env.NODE_ENV && (Mt.propTypes = {
  to: p.string.isRequired
});
var Lt = function Lt(t) {
    return t instanceof Bt;
  },
  Vt = function (t) {
    function e() {
      return Ot(this, e), Pt(this, t.apply(this, arguments));
    }
    return xt(e, t), e.prototype.componentDidMount = function () {
      var t = this.props,
        e = t.navigate,
        n = t.to,
        r = t.replace,
        o = void 0 === r || r,
        i = t.state,
        a = t.baseuri,
        u = _t(t, ["navigate", "to", "from", "replace", "state", "noThrow", "baseuri"]);
      Promise.resolve().then(function () {
        var t = ct(n, a);
        e(st(t, u), {
          replace: o,
          state: i
        });
      });
    }, e.prototype.render = function () {
      var t = this.props,
        e = t.to,
        n = t.noThrow,
        r = t.baseuri,
        o = _t(t, ["navigate", "to", "from", "replace", "state", "noThrow", "baseuri"]),
        i = ct(e, r);
      return n || function (t) {
        throw new Bt(t);
      }(st(i, o)), null;
    }, e;
  }(e.Component),
  $t = function $t(t) {
    return e.createElement(Nt.Consumer, null, function (n) {
      var r = n.baseuri;
      return e.createElement(St, null, function (n) {
        return e.createElement(Vt, Et({}, n, {
          baseuri: r
        }, t));
      });
    });
  };
"production" !== process.env.NODE_ENV && ($t.propTypes = {
  from: p.string,
  to: p.string.isRequired
});
var zt = function zt(t) {
    return t.replace(/(^\/+|\/+$)/g, "");
  },
  Gt = function t(n) {
    return function (r) {
      if (!r) return null;
      if (r.type === e.Fragment && r.props.children) return e.Children.map(r.props.children, t(n));
      var o, i;
      if (r.props.path || r.props.default || r.type === $t || ("production" !== process.env.NODE_ENV ? L(!1, "<Router>: Children of <Router> must have a `path` or `default` prop, or be a `<Redirect>`. None found on element type `" + r.type + "`") : L(!1)), r.type !== $t || r.props.from && r.props.to || ("production" !== process.env.NODE_ENV ? L(!1, '<Redirect from="' + r.props.from + '" to="' + r.props.to + '"/> requires both "from" and "to" props when inside a <Router>.') : L(!1)), r.type === $t && (o = r.props.to, i = function i(t) {
        return pt(t);
      }, dt(r.props.from).filter(i).sort().join("/") !== dt(o).filter(i).sort().join("/")) && ("production" !== process.env.NODE_ENV ? L(!1, '<Redirect from="' + r.props.from + ' to="' + r.props.to + '"/> has mismatched dynamic segments, ensure both paths have the exact same dynamic segments.') : L(!1)), r.props.default) return {
        value: r,
        default: !0
      };
      var a = r.type === $t ? r.props.from : r.props.path,
        u = "/" === a ? n : zt(n) + "/" + zt(a);
      return {
        value: r,
        default: r.props.default,
        path: r.props.children ? zt(u) + "/*" : u
      };
    };
  },
  Kt = function Kt(t) {
    return !t.defaultPrevented && 0 === t.button && !(t.metaKey || t.altKey || t.ctrlKey || t.shiftKey);
  };
function Yt() {
  var t = bt.location,
    _r23 = r(t),
    _r24 = _slicedToArray(_r23, 2),
    e = _r24[0],
    n = _r24[1];
  return i(function () {
    var t = bt.listen(function (t) {
      var e = t.location;
      n(e);
    });
    return function () {
      t();
    };
  }, []), e;
}
function Ht(t) {
  var e = o();
  return i(function () {
    e.current = t;
  }, [t]), e.current;
}
function Jt() {
  var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var _r25 = r(t),
    _r26 = _slicedToArray(_r25, 2),
    e = _r26[0],
    n = _r26[1];
  return [e, {
    has: function has(t) {
      return e.includes(t);
    },
    add: function add(t) {
      n(function (e) {
        return e.includes(t) ? e : [].concat(_toConsumableArray(e), [t]);
      });
    },
    delete: function _delete(t) {
      n(function (e) {
        var n = e.indexOf(t);
        return -1 !== n ? [].concat(_toConsumableArray(e.slice(0, n)), _toConsumableArray(e.slice(n + 1))) : e;
      });
    },
    toggle: function toggle(t) {
      n(function (e) {
        var n = e.indexOf(t);
        return -1 !== n ? [].concat(_toConsumableArray(e.slice(0, n)), _toConsumableArray(e.slice(n))) : [].concat(_toConsumableArray(e), [t]);
      });
    }
  }];
}
m();
var Qt = process.env.GATSBY_STORE_NAME || "gatsby/store",
  Xt = y() ? r : k ? function (t) {
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.localStorage;
    var n = e.getItem(t);
    return function (o) {
      var _r27 = r(null === n ? o : JSON.parse(n)),
        _r28 = _slicedToArray(_r27, 2),
        a = _r28[0],
        u = _r28[1],
        c = JSON.stringify(a);
      return i(function () {
        e.setItem(t, c);
      }, [c]), [a, u];
    };
  }(Qt) : v(Qt),
  Zt = u([null, function () {}]);
function te(t) {
  var e = t.initialState,
    r = function (t, e) {
      if (null == t) return {};
      var n,
        r,
        o = {},
        i = Object.keys(t);
      for (r = 0; r < i.length; r++) e.indexOf(n = i[r]) >= 0 || (o[n] = t[n]);
      return o;
    }(t, ["initialState"]);
  var o = Zt.Provider,
    _Xt = Xt(e),
    _Xt2 = _slicedToArray(_Xt, 2),
    i = _Xt2[0],
    a = _Xt2[1];
  return h(o, O({}, r, {
    value: [null == i ? e : i, n(function (t) {
      a(function (n) {
        return d(null == n ? e : n, t);
      });
    }, [])]
  }));
}
function ee() {
  return a(Zt);
}
function ne(t) {
  var _r29 = r(0),
    _r30 = _slicedToArray(_r29, 2),
    e = _r30[0],
    n = _r30[1],
    a = o();
  return i(function () {
    return a.current = setInterval(function () {
      n(function (t) {
        return t + 1;
      });
    }, t), function () {
      clearInterval(a.current);
    };
  }, []), e;
}
function re(t) {
  var e = Yt(),
    n = s(function () {
      return w(t).map(function (t) {
        return t.name;
      }).filter(Boolean);
    }, [t]),
    o = s(function () {
      var e = b(t, {
        decode: decodeURIComponent
      });
      return function (_ref6) {
        var t = _ref6.pathname,
          n = _ref6.search;
        var r = e(t);
        return r ? O({}, r.params, _.parse(n)) : null;
      };
    }, [t]),
    _r31 = r(null),
    _r32 = _slicedToArray(_r31, 2),
    a = _r32[0],
    u = _r32[1];
  return i(function () {
    u(o(e));
  }, [e.pathname, e.search]), i(function () {
    if (a) {
      var _e = E(t, {
          encode: encodeURIComponent
        })(a),
        _r33 = _.stringify(g(a, n));
      window.history.replaceState(null, "", "".concat(_e).concat(_r33 ? "?" + _r33 : ""));
    }
  }, [a]), [a || {}, u];
}
export { U as BEM, S as BEMProvider, M as IE11, B as NotIE11, Qt as STORE_NAME, te as StoreProvider, x as bem, C as bemContext, k as isIE11, Zt as storeContext, P as useAxios, R as useBEM, D as useComponentSize, j as useDataApi, W as useDeepCompareEffect, A as useHasMounted, q as useIsIE11, I as useIsNotIE11, Yt as useLocation, Ht as usePrevious, Jt as useSet, ee as useStore, ne as useTicker, re as useURLParams };